/**
 * Method: initBoxLink
 *
 * Making div/boxes linkable rather than just only link or image. Use data-box-url attribute
 *
 * @return void
 */
export function initBoxLink() {
  let links = document.querySelectorAll('[data-box-url]');
  if (links) {
    Array.prototype.forEach.call(links, function (link) {
      link.style.cursor = 'pointer';
      link.addEventListener('click', function (e) {
        window.location.href = link.dataset.boxUrl;
      });
    });
  }
}
